<!-- 选择商户 -->
<template>
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="shopId"
      :searchList="searchList"
      :columns="columns"
      :searchParams.sync="searchParams"
      :listApi="listApi"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';

export default {
  mixins: [fetchSelect],
  data () {
    return {
      searchList: [
        {
          label: '',
          props: ['areas'],
          placeholder: '所在地区',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(0, 'searchList', '1,2', e);
          }
        },
        { props: ['shopName'], placeholder: '店铺名称', options: [], inputType: 'input' }

      ],
      columns: [
        { title: '所在地区', dataIndex: 'area', align: 'left', width: '' },
        { title: '店铺名称', dataIndex: 'shopName', align: 'left', width: '' }
      ],
      dataSource: [],
      searchParams: {
        areas: undefined,
        shopName: undefined
      },
      listApi: {
        url: '/local/leader/shopList',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {

    /* 获取下拉 */
    getSelect () {
      this.regionSelect(0, 'searchList', '1,2');
    },
    resHandle (res) {
      return res.rows;
    },
    searchHandle (selectData) {
    },
    getSelectId () {
      if (this.$refs.table.selectedRowKeys) {
        return this.$refs.table.selectedRowKeys;
      } else {
        return [];
      }
    },
    getSelectrow () {
      if (this.$refs.table.selectedRowKeys) {
        return this.$refs.table.selectedRows;
      } else {
        return [];
      }
    }
  }
};
</script>
